<template>
    <div style="display: none;"></div>
</template>
<script>
export default {
    name: 'tamsense-metric',
    props: {
        options: {
            type: Object,
            default: () => ({
                endpoint: 'https://my.tamsense.com/api/scenes',
                apiKey: 'tk_6cbae524016v54b7788ut648097u4sd43c32c1f66y1wu009',
                debug: 'verbose',
            }),
        },
    },
    mounted() {
        this.$store.dispatch('users/checkCookieConsent');
        this.load();
    },
    computed: {
        cookieConsent() {
            return this.$store.state.users.cookieConsent;
        },
        user() {
            return this.$store.getters['users/user'];
        },
    },
    methods: {
        load() {
            if (window.Scene) {
                this.init();
                return;
            }

            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://unpkg.com/@konantur/scene@0.4.0/dist/index.global.js';
            script.onload = this.init;
            script.onerror = () => console.error('Ошибка tamsense');

            const firstScript = document.getElementsByTagName('script')[0];
            firstScript.parentNode.insertBefore(script, firstScript);
        },
        init() {
            window.Scene.init(this.options);
            this.setUser();
        },
        setUser() {
            if (this.user && this.user.id && window.Scene) {
                window.Scene.setUser(this.user.id);
            }
        },
    },
    watch: {
        cookieConsent(newVal) {
            if (newVal) {
                this.load();
            }
        },
        user(newUser) {
            if (newUser) {
                this.setUser();
            }
        },
    },
};
</script>
